// CGU CommunityPlace (marketplace) & Mentions légales LCEN — textes officiels fournis par l'éditeur (10/09/2026)

export const cgOscopContent = {
  id: "cg-oscop",
  title: "Conditions Générales d'Utilisation (CGU)",
  subtitle: "Plateforme Marketplace « CommunityPlace »",
  version: "{{VERSION}}",
  dateEffet: "{{DATE_EFFET}}",
  reference: "CGU-CPLACE-2026-001",
  entity: "O'SCOP",
  accentColor: "#D4AF37",
  sections: [
    {
      number: "§",
      title: "Préambule",
      content: `La société **OBJECTIF SCOP OUTREMER**, SCIC SAS au capital variable, immatriculée au Registre du Commerce et des Sociétés de Pointe-à-Pitre sous le numéro **903 459 139**, dont l'établissement est situé au 13 rue Rodrigue YOUYOUTE, 97139 Les Abymes (ci-après « l'Opérateur »), édite et exploite la plateforme en ligne accessible à l'adresse lacentrale.objectifscopoutremer.com (ci-après « CommunityPlace »).

CommunityPlace est une place de marché numérique (marketplace) qui permet à des professionnels de l'économie sociale et solidaire ultramarine régulièrement inscrits (ci-après « les Vendeurs ») d'entrer en relation avec des acheteurs professionnels ou particuliers (ci-après « les Acheteurs ») afin de leur vendre directement des produits ou des services.

**L'Opérateur intervient exclusivement en qualité d'intermédiaire technique de mise en relation.** Sauf mention expresse contraire, l'Opérateur n'est pas partie aux contrats de vente conclus directement et librement entre les Vendeurs et les Acheteurs sur la plateforme.`
    },
    {
      number: "1",
      title: "Acceptation et modification des CGU",
      content: `**1.1. Acceptation** — L'accès, la navigation et l'utilisation de CommunityPlace sont conditionnés à l'acceptation pleine, entière et sans réserve des présentes CGU par l'utilisateur (qu'il soit Vendeur, Acheteur ou simple visiteur). Cette acceptation est matérialisée par une case à cocher lors de la création du compte membre.

**1.2. Modification** — L'Opérateur se réserve le droit de modifier les présentes CGU à tout moment afin de les adapter aux évolutions techniques de la plateforme, à son modèle économique ou à la réglementation en vigueur. Les utilisateurs seront informés de toute modification substantielle avec un préavis raisonnable. La poursuite de l'utilisation de la plateforme après l'entrée en vigueur des modifications vaut acceptation des nouvelles CGU.`
    },
    {
      number: "2",
      title: "Conditions d'accès et création de compte",
      content: `**2.1. Inscription des Acheteurs** — La création d'un compte utilisateur est gratuite et obligatoire pour effectuer un achat sur CommunityPlace. L'Acheteur s'engage à fournir des informations exactes et à jour.

**2.2. Inscription et Éligibilité des Vendeurs** — L'accès à la plateforme en qualité de Vendeur est strictement réservé aux professionnels :
- Régulièrement immatriculés (justificatif SIRET, extrait Kbis ou équivalent requis).
- Répondant aux critères d'adhésion ou d'affiliation des dispositifs d'intérêt collectif gérés par l'Opérateur (dispositifs FTPE Outremer, RCDS BATICO, etc.).

**2.3. Sécurité des identifiants** — Chaque membre est seul responsable de la confidentialité et de la sécurité de ses identifiants de connexion (adresse e-mail et mot de passe). Tout accès ou transaction réalisé à l'aide de ces identifiants sera réputé effectué par l'utilisateur lui-même. En cas de perte ou de vol, l'utilisateur doit en informer immédiatement l'Opérateur.`
    },
    {
      number: "3",
      title: "Rôle et limitation de responsabilité de l'Opérateur",
      highlight: true,
      content: `**3.1. Statut d'intermédiaire technique** — L'Opérateur agit en qualité d'hébergeur au sens de l'article 6-I-2 de la Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN). À ce titre, l'Opérateur n'exerce aucun contrôle a priori sur les offres, descriptifs, prix, garanties ou légalité des produits et services proposés par les Vendeurs.

**3.2. Exonération de responsabilité commerciale** — Le contrat de vente est formé exclusivement entre l'Acheteur et le Vendeur. Par conséquent, l'Opérateur ne saurait être tenu responsable :
- De la conformité, de la qualité, de la sécurité ou de la licéité des produits et services vendus.
- Des retards de livraison, défauts de livraison, ou dommages survenus durant le transport.
- Du service après-vente, de l'exercice du droit de rétractation ou de tout litige commercial né de la transaction.`
    },
    {
      number: "4",
      title: "Obligations des Vendeurs",
      content: `Chaque Vendeur s'engage expressément à :
- **Transparence** : fournir des fiches produits ou services fidèles, transparentes et complètes (caractéristiques essentielles, prix toutes taxes comprises ou hors taxes selon le statut, frais et délais de livraison).
- **Cadre contractuel** : mettre à disposition des Acheteurs ses propres Conditions Générales de Vente (CGV) conformes au Code de la consommation (notamment concernant le droit de rétractation de 14 jours pour les particuliers).
- **Légalité** : ne proposer aucun produit ou service illicite, contrefait ou enfreignant des droits de propriété intellectuelle tiers.`
    },
    {
      number: "5",
      title: "Transparence et référencement des offres",
      content: `Conformément à la législation sur la transparence des plateformes en ligne :
- **Classement par défaut** : les offres des Vendeurs sont classées par pertinence textuelle, par catégorie ou par ordre chronologique de mise en ligne.
- **Modération et déréférencement** : l'Opérateur se réserve le droit de retirer sans préavis une offre ou de suspendre le compte d'un Vendeur en cas de non-respect flagrant des présentes CGU, d'infraction à la loi, ou de signalements répétés et fondés de la part des Acheteurs.`
    },
    {
      number: "6",
      title: "Modèle économique – Accès par abonnement",
      highlight: true,
      content: `**6.1. Absence de commission** — L'Opérateur applique un modèle transparent d'économie solidaire : **aucune commission n'est prélevée par OBJECTIF SCOP OUTREMER sur le montant des ventes réalisées entre les utilisateurs sur CommunityPlace**.

**6.2. Redevance d'accès (Abonnement)** — La possibilité de publier des offres et de vendre sur CommunityPlace est conditionnée par la souscription préalable et le maintien actif d'une formule d'abonnement (mensuelle ou annuelle) payée par le Vendeur à l'Opérateur, selon les tarifs en vigueur définis dans les conditions financières de la SCIC.

**6.3. Suspension pour impayé** — À défaut de paiement de l'abonnement à l'échéance, l'Opérateur enverra une notification de rappel. Si la situation n'est pas régularisée dans un délai de huit (8) jours, l'Opérateur pourra suspendre l'affichage des offres du Vendeur défaillant jusqu'au complet paiement des sommes dues.`
    },
    {
      number: "7",
      title: "Système de paiement sécurisé intégré",
      content: `**7.1. Partenaire de paiement tierce partie** — Pour assurer la sécurité des flux financiers, CommunityPlace intègre une solution de paiement en ligne sécurisée opérée par un prestataire de services de paiement agréé (ci-après « le PSP », type Stripe ou MangoPay).

**7.2. Encaissement pour compte de tiers** — En s'inscrivant sur la plateforme, le Vendeur accepte les conditions générales d'utilisation du PSP et lui donne mandat pour encaisser en son nom et pour son compte les sommes versées par les Acheteurs. Les fonds sont mis sous séquestre sur un compte de cantonnement sécurisé géré par le PSP avant d'être reversés sur le compte bancaire du Vendeur, déduction faite des éventuels frais techniques de transaction propres au réseau bancaire du PSP.`
    },
    {
      number: "8",
      title: "Obligations fiscales et sociales",
      content: `Conformément aux dispositions de l'article 242 bis du Code général des impôts :
- **Responsabilité déclarative** : les Vendeurs professionnels sont seuls responsables du calcul, de la déclaration et du paiement de la taxe sur la valeur ajoutée (TVA) – en tenant compte des taux spécifiques applicables dans les territoires d'Outre-mer (Guadeloupe, Martinique, Réunion, etc.) –, de l'impôt sur les sociétés ou sur le revenu, ainsi que des cotisations sociales afférentes aux ventes réalisées.
- **Récapitulatif annuel** : l'Opérateur mettra à disposition de chaque Vendeur, avant le 31 janvier de chaque année, un document récapitulant le nombre et le montant brut des transactions réalisées par son intermédiaire au cours de l'année précédente.`
    },
    {
      number: "9",
      title: "Propriété intellectuelle",
      content: `Tous les éléments textuels, graphiques, logos, designs, icônes et codes sources de la plateforme CommunityPlace et du sous-domaine lacentrale.objectifscopoutremer.com sont la propriété exclusive de l'Opérateur ou de ses partenaires. Toute reproduction, copie ou exploitation non autorisée, par quelque procédé que ce soit, est strictement interdite et constitue une contrefaçon sanctionnée par le Code de la propriété intellectuelle.`
    },
    {
      number: "10",
      title: "Loi applicable et juridiction compétente",
      content: `Les présentes CGU sont régies, interprétées et appliquées conformément au **droit français**.

En cas de contestation ou de litige relatif à la validité, l'interprétation ou l'exécution des présentes CGU, et à défaut de résolution amiable, compétence expresse et exclusive est attribuée aux **tribunaux compétents de Pointe-à-Pitre**, nonobstant pluralité de défendeurs ou appel en garantie.`
    }
  ]
};

export const mentionsLegalesContent = {
  id: "mentions-legales",
  title: "Mentions légales",
  subtitle: "LCEN — Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique",
  version: "{{VERSION}}",
  dateEffet: "{{DATE_EFFET}}",
  reference: "ML-OSCOP-2026-001",
  entity: "O'SCOP",
  accentColor: "#D9B35A",
  sections: [
    {
      number: "§",
      title: "Cadre légal",
      content: `Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), il est précisé aux utilisateurs du site **centrale.objectifscopoutremer.com** l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.`
    },
    {
      number: "1",
      title: "Éditeur du site",
      content: `Le présent site internet est édité par la société :
- **Dénomination sociale** : OBJECTIF SCOP OUTREMER (Enseigne : O'SCOP)
- **Forme juridique** : SCIC SAS (Société Coopérative d'Intérêt Collectif sous forme de Société par Actions Simplifiée) à capital variable — capital social : 1 500 € ; capital variable minimum : 1 500 €
- **Adresse du siège social et de l'établissement éditeur** : 13 rue Rodrigue YOUYOUTE, 97139 Les Abymes, Guadeloupe (France)
- **Numéro SIREN** : 903 459 139
- **Numéro SIRET (siège)** : 903 459 139 00015
- **Inscription au RCS** : immatriculée au Registre du Commerce et des Sociétés (RCS) de Pointe-à-Pitre sous le numéro 903 459 139
- **Numéro de TVA intracommunautaire** : FR34903459139
- **Adresse e-mail de contact** : contact@objectifscopoutremer.com`
    },
    {
      number: "2",
      title: "Direction de la publication",
      content: `**Direction de la publication** : Félixia PIPEROL, présidente de la SCIC.`
    },
    {
      number: "3",
      title: "Hébergement du site",
      content: `Le site **centrale.objectifscopoutremer.com** est déployé au moyen de l'infrastructure applicative d'Emergent :
- **Prestataire technique** : Emergent Labs Inc.
- **Adresse** : 2380 Via Espada, Pleasanton, CA 94566, États-Unis
- **Assistance** : support@emergent.sh
- **Infrastructure de diffusion** : services cloud et réseau de diffusion de contenu utilisés par Emergent

Les traitements et transferts associés sont décrits dans la politique de confidentialité.`
    },
    {
      number: "4",
      title: "Propriété intellectuelle et conditions d'accès",
      content: `L'ensemble des contenus présents sur le sous-domaine centrale.objectifscopoutremer.com est protégé par les lois en vigueur au titre de la propriété intellectuelle. Toute reproduction, modification ou distribution non autorisée de ces éléments est strictement interdite.`
    }
  ]
};
